type CSSProperties = {
  [key: string]: React.CSSProperties;
};

export class StyleSheet {
  static create<Styles extends CSSProperties>(styles: Styles): Styles {
    return styles;
  };
};

const styles = StyleSheet.create({
  backgroundImage: {
    backgroundColor: '#0C2461',
  },
  backgroundLogin: {
    backgroundColor: '#F6F7F8',
    height: '90.5%'
  },
  backgroundLogin2: {
    backgroundColor: '#FFFFFF',
    font: 'normal normal normal calc(0.2em + 0.7vw) Montserrat',
    letterSpacing: '0px',
    color: '#707070',
    opacity: '1',
    height:'9.5%'
  },
  textFontBlue: {
    textAlign: 'left',
    font: 'normal normal bold calc(0.5em + 0.8vw) Montserrat',
    letterSpacing: '0px',
    color: '#0C2461',
    opacity: '1'

  },
  textFontGlay: {
    textAlign: 'left',
    font: 'normal normal normal calc(0.2em + 0.7vw) Montserrat',
    letterSpacing: '0px',
    color: '#707070',
    opacity: '1',

  },
  LinkGlay: {
    textDecoration: 'none',
    color: '#707070',
    font: 'normal normal normal calc(0.2em + 0.7vw) Montserrat',
  },
  textBlack: {
    textAlign: 'left',
    font: 'normal normal bold calc(0.5em + 0.5vw) Montserrat',
    letterSpacing: '0px',
    color: '#1E1E1E',
    opacity: 1,
    textDecoration: 'none', 
    backgroundColor: 'transparent',
     border: 'none',
     cursor:'pointer'
  },
  textBlackAction: {
    textAlign: 'left',
    font: 'normal normal bold calc(0.5em + 0.5vw) Montserrat',
    letterSpacing: '0px',
    color: '#1E1E1E',
    opacity: 1,
    textDecoration: 'underline',
    backgroundColor: 'transparent',
     border: 'none',
     cursor:'pointer'
  },
  textBlackNoPointer: {
    textAlign: 'left',
    font: 'normal normal bold calc(0.5em + 0.5vw) Montserrat',
    letterSpacing: '0px',
    color: '#1E1E1E',
    opacity: 1,
    textDecoration: 'none', 
    backgroundColor: 'transparent',
     border: 'none',
  },
});

export default styles;






